export default {
  getSaasOrgData (state) {
    return state.saasOrgData
  }
}
